import React from "react";
import { Container } from "react-bootstrap";
import fintech from "../../../../Asset/hero-fintech-2.svg";

const Last = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ background: "var( --light-primary-bg)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-1">
              <div className="info-content">
                <div className="title-paragraph">
                  Why Choose Codeffi for Fintech Web Development and Digital
                  Services?
                </div>
                <p>
                  You can choose Codeffi for all periods of Fintech web
                  improvement and plan, and we want to believe that you
                  investigate our administration page to look further into the
                  kinds of innovation we use and our development interaction.
                </p>
                <p>
                  Other than Fintech web and application development, we have
                  insight into Software improvement, search promotion, Ai and
                  IoT, investigation, content showcasing, and UI and UX plan. We
                  work with a wide range of associations — from new companies
                  and independent ventures to non-benefit and worldwide
                  endeavors that arrange with both B2B and B2C client models. At
                  Codeffi, we can step in at any phase of your undertaking —
                  from the beginning vital wanting to help.
                </p>
                <p>
                  We need to help your business with Fintech web development and
                  configuration projects that will assist you with drawing in
                  clients and permit your representatives to work all the more
                  proficiently.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-2">
              <div className="info-img">
                <img alt="infoImage" src={fintech} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Last;
